import { memo } from 'react';
import StepCSSTransitionGroup from '@wg/wows-react-uikit/components/Animations/StepCSSTransitionGroup';
import ClanName from '@wg/wows-react-uikit/components/ClanName/ClanName';
import PageTitle from '@wg/wows-react-uikit/components/PageTitle/PageTitle';

import { t } from '~/helpers/localization';

import Back from '~/UIKit/Back/Back';

import styles from './ClanProfile.module.scss';

import type { ClanInfoType } from '~/Actions/ActionClanProfile';

interface ClanProfileDisbandedMessageProps {
  clan: ClanInfoType;
}

const ClanProfileMessageDisbanded = ({ clan }: ClanProfileDisbandedMessageProps) => (
  <div>
    <div className={styles.back}>
      <Back />
    </div>
    <StepCSSTransitionGroup level={1}>
      <PageTitle key="page-title" title={<ClanName clanTag={clan.tag} clanColor={clan.color} clanName={clan.name} />} />
    </StepCSSTransitionGroup>
    <StepCSSTransitionGroup level={2}>
      <div className={styles.message}>
        <p className={styles.messageText}>{t('Информация недоступна: клан распущен')}</p>
      </div>
    </StepCSSTransitionGroup>
  </div>
);

export default memo(ClanProfileMessageDisbanded);
